do ->
  return unless _?

  mixins =
    average: (obj, key) ->
      _.sum(obj, key) / _.size(obj)

    median: (arr) ->
      middle = (arr.length + 1) / 2
      sorted = _.sortBy(arr, _.identity)

      if _.isInteger(middle)
        sorted[middle - 1]
      else
        _.sum(sorted.slice(middle - 1.5, middle + 0.5)) / 2

    # Get the closest value to `n` in an array.
    nearest: (arr, n, range = [-1, 999]) ->
      _.chain(arr)
        .map((m) -> [m, Math.abs(m - n)])
        .reduce(((m, v) -> if m[1] < v[1] then m else v), range)
        .first()
        .value()

    # Add the numbers in an array, or pluck the key from each object in the
    # array and add those together
    sum: (obj, key = "value") ->
      arr =
        if _.isArray(obj) and _.isNumber(obj[0])
          obj
        else
          _.pluck(obj, key)

      _.reduce(arr, (m, i) -> m + i)

    # Get the factors of `n` as an array.
    factors: (n) ->
      ((n / d) for d in [0..n] when _.isInteger(n / d)).reverse()

    # What sort of number is it?
    isInteger: (n) ->
      _.hasFactor(n, 1)

    isEven: (n) ->
      _.hasFactor(n, 2)

    isOdd: (n) ->
      not _.isEven(n)

    # Is `d` a factor of `n`?
    hasFactor: (n, d) ->
      n % d is 0

    # `n` constrained by min and max values
    limit: (n, min, max = 0) ->
      if min < max
        Math.max(Math.min(n, max), min)
      else if min > max
        Math.min(Math.max(n, max), min)
      else
        min

  _.mixin(mixins)
